import { Lesson } from "@/models/Lesson.js"
import { LessonOffer, LessonOffers, OfferStatus } from "@/models/LessonOffer"
import { Schedule } from "@/models/Schedule.js"
import firebase from 'firebase/app'

class LessonOfferRepository {
  constructor (client) {
    this.collection = client.collection("lessonOffers")
    this.snapShotOptions = { serverTimestamps : 'estimate' }
  }

  async put(
    lessonData,
    senderId,
    receiverId
  ) {
    const docRef = await this.collection.doc()
    const lesson = new Lesson(
      docRef.id,
      lessonData.teacherId,
      lessonData.parentId,
      lessonData.studentId,
      new Schedule(
        lessonData.schedule.day,
        lessonData.schedule.start,
        lessonData.schedule.end
      ),
      lessonData.wage,
      lessonData.note
    )
    const timestamp = firebase.firestore.FieldValue.serverTimestamp()
    const offer = new LessonOffer(
      docRef.id,
      lesson,
      senderId,
      receiverId,
      OfferStatus.inOffer,
      timestamp,
      timestamp
    )
    const object = offer.toObject()
    await docRef.set(object.data)
    const result = await docRef.get()
    const data = result.data(this.snapShotOptions)
    return createOfferFromFireStoreData(result.id, data)
  }

  async get(id) {
    const result = await this.collection.doc(id).get()
    const data = result.data(this.snapShotOptions)
    return createOfferFromFireStoreData(id, data)
  }

  async listOfInOffer(receiverId) {
    const snapShot = await this.collection.where("receiverId", "==", receiverId).where("status", "==", OfferStatus.inOffer).get()
    let arr = []
    snapShot.forEach(doc => {
      arr.push(createOfferFromFireStoreData(doc.id, doc.data()))
    })
    return createOffers(arr)
  }

  async listOfAllOffers(senderId) {
    const snapShot = await this.collection.where("senderId", "==", senderId).get()
    let arr = []
    snapShot.forEach(doc => {
      arr.push(createOfferFromFireStoreData(doc.id, doc.data()))
    })
    return createOffers(arr)
  }

  async agree(offer) {
    const timestamp = firebase.firestore.FieldValue.serverTimestamp()
    const offerObject = offer.toObject()
    offerObject.data.updatedAt = timestamp
    offerObject.data.status = OfferStatus.agreed
    const docRef = await this.collection.doc(offerObject.id)
    docRef.set(offerObject.data)
    const result = await docRef.get()
    const data = result.data(this.snapShotOptions)
    return createOfferFromFireStoreData(offerObject.id, data)
  }

  async disagree(offer) {
    const timestamp = firebase.firestore.FieldValue.serverTimestamp()
    const offerObject = offer.toObject()
    offerObject.data.updatedAt = timestamp
    offerObject.data.status = OfferStatus.disagreed
    const docRef = await this.collection.doc(offerObject.id)
    docRef.set(offerObject.data)
    const result = await docRef.get()
    const data = result.data(this.snapShotOptions)
    return createOfferFromFireStoreData(offerObject.id, data)
  }

  async delete(offer) {
    return await this.collection.doc(offer.id).delete()
  }

}
const createLessonFromFireStoreData = (id, data) => {
  return new Lesson(
    id,
    data.teacherId,
    data.parentId,
    data.studentId,
    new Schedule(
      data.schedule.day,
      data.schedule.start,
      data.schedule.end
    ),
    data.wage,
    data.note
  )
}

const createOfferFromFireStoreData = (id, data) => {
  return new LessonOffer(
    id,
    createLessonFromFireStoreData(data.lesson.id, data.lesson.data),
    data.senderId,
    data.receiverId,
    data.status,
    data.createdAt.toDate(),
    data.updatedAt.toDate()
  )
}

const createOffers = (arr) => {
  return new LessonOffers(arr)
}

export { LessonOfferRepository }